import React, { useEffect, useState, useCallback } from "react";
import Layout from "../Layout";
import ImageMapper from "react-img-mapper";
import axios from "axios";
import * as Unicons from "@iconscout/react-unicons";
import { ToastContainer, toast } from "react-toastify";
import Loader from "./../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";
import NoResultsComponent from "./../../components/NoResultsComponent";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import Pdf from "./Pdf";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import Img from "../../components/Img";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { IMG_SERVER_URL } from "../../utils/constant";
import ImgOptimized from "../../components/ImgOptimized";

const Moodboard = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  var { floorId } = useParams();
  const [chooseImages, setChooseImages] = useState([]);
  const [popup, setPopup] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]); // Changed to array for multiple selections
  const [imageArea, setImageArea] = useState();
  const [floorPlan, setFloorPlan] = useState({});
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [mainTag, setMainTag] = useState("");
  const [pdfView, setPdfView] = useState(false);

  const [furniture, setFurniture] = useState([]);
  const [furniturePopup, setFurniturePopup] = useState(false);
  const [chooseFurniture, setChooseFurniture] = useState([]);
  const [furnitureTag, setFurnitureTag] = useState("");
  const [furniturepage, setFurniturePage] = useState(1);
  const [hasFurnitureMore, setHasFurnitureMore] = useState(true);
  const [selectedFurnitureOptions, setSelectedFurnitureOptions] = useState([]); // Changed to array for multiple selections

  const [extraFurniture, setExtraFurniture] = useState([]);
  const moodBoardUserAPI = useSelector(
    (state) => state.moodBoardUser.moodBoardUser,
  );

  const token = localStorage.getItem("usersdatatoken");
  const axiosConfig = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const URL = `${IMG_SERVER_URL}/floorplan/${floorId}.jpg`;
  const MAP = {
    name: "my-map",
    areas: floorPlan?.maps || "loading...",
  };

  const getFloorPlan = async () => {
    setLoading(true);
    try {
      const floorResponse = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/floor/get/${floorId}`,
          axiosConfig,
        ),
      ]);
      setFloorPlan(floorResponse[0].data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getFloorPlan();
  }, []);

  const openImagePopup = (area) => {
    fetchImages(area.Tag);
    setImageArea(area);
    setPopup(true);
    setMainTag(area.Tag);
    setSelectedOptions([]); // Reset selections when opening popup
  };

  const openFurniturePopup = (fTag) => {
    fetchFurniture(fTag);
    setFurniturePopup(true);
    setFurnitureTag(fTag);
    setSelectedFurnitureOptions([]); // Reset selections when opening popup
  };

  // Toggle selection of an image
  const toggleImageSelection = (option) => {
    const optionValue = `/${option._id}`;

    // Check if the option is already selected
    if (selectedOptions.includes(optionValue)) {
      // Remove it if already selected
      setSelectedOptions(
        selectedOptions.filter((item) => item !== optionValue),
      );
    } else {
      // Add it if not selected
      setSelectedOptions([...selectedOptions, optionValue]);
    }
  };

  // Toggle selection of furniture
  const toggleFurnitureSelection = (option) => {
    const optionValue = `${option.Mask}/${option.ID}`;

    // Check if the option is already selected
    if (selectedFurnitureOptions.includes(optionValue)) {
      // Remove it if already selected
      setSelectedFurnitureOptions(
        selectedFurnitureOptions.filter((item) => item !== optionValue),
      );
    } else {
      // Add it if not selected
      setSelectedFurnitureOptions([...selectedFurnitureOptions, optionValue]);
    }
  };

  const closeImagePopup = () => {
    const substrings = ["Glass", "Table", "Lights"];
    const containsSubstring = selectedOptions.some((option) =>
      substrings.some((substring) =>
        option.toLowerCase().includes(substring.toLowerCase()),
      ),
    );

    if (containsSubstring) {
      // Add all selected images to extraFurniture
      const updatedFurniture = [...extraFurniture];

      selectedOptions.forEach((option) => {
        if (!updatedFurniture.includes(option)) {
          updatedFurniture.push(option);
        }
      });

      setExtraFurniture(updatedFurniture);
    } else if (selectedOptions.length > 0) {
      // For regular floor areas, add images to the map
      const updatedMaps = floorPlan?.maps?.map((item) => {
        if (item.id === imageArea.id) {
          // Store multiple images in the 'images' array property
          return {
            ...item,
            images: selectedOptions, // Store all selected images
            img: selectedOptions[0], // Keep the first one as the primary for backward compatibility
            preFillColor: "rgba(0,0,0,0.6)",
          };
        }
        return item;
      });

      setFloorPlan({ ...floorPlan, maps: updatedMaps });
    }

    // Reset states and close popup
    setPopup(false);
    setSelectedOptions([]);
    setChooseImages([]);
    setHasMore(true);
    setPage(1);
  };

  const closeFurniturePopup = () => {
    if (selectedFurnitureOptions.length > 0) {
      // Add all selected furniture to the furniture array
      const updatedFurniture = [...furniture];

      selectedFurnitureOptions.forEach((option) => {
        if (!updatedFurniture.includes(option)) {
          updatedFurniture.push(option);
        }
      });

      setFurniture(updatedFurniture);
    }

    // Reset states and close popup
    setFurniturePopup(false);
    setSelectedFurnitureOptions([]);
    setChooseFurniture([]);
    setHasFurnitureMore(true);
    setFurniturePage(1);
  };
  console.log(furniture, "furnitures", selectedFurnitureOptions);
  // Rest of your fetchImages and fetchFurniture functions remain the same
  const fetchImages = async (tag) => {
    try {
      if (tag || mainTag) {
        const response = await fetch(
          `${process.env.REACT_APP_BACK_URL}/api/image/filter?tags=${
            tag || mainTag
          }&limit=50&page=${page}`,
          axiosConfig,
        );
        const data = await response.json();
        if (data.images.length === 0) {
          setHasMore(false);
        } else {
          setChooseImages((prevImages) => [...prevImages, ...data.images]);
          setPage(page + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const fetchFurniture = async (tag) => {
    try {
      if (tag || furnitureTag) {
        const response = await fetch(
          `${process.env.REACT_APP_BACK_URL}/api/furniture/filter?tags=${
            tag || furnitureTag
          }&limit=10&page=${furniturepage}`,
          axiosConfig,
        );
        const data = await response.json();
        if (data?.furniture.length === 0) {
          setHasFurnitureMore(false);
        } else {
          setChooseFurniture((prevImages) => [
            ...prevImages,
            ...data.furniture,
          ]);
          setFurniturePage(furniturepage + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const deleteFloorImg = (item, specificImage = null) => {
    // For extraFurniture items (strings)
    if (typeof item === "string") {
      const updatedFurniture = extraFurniture.filter((map) => map !== item);
      setExtraFurniture(updatedFurniture);
    }
    // For floorPlan map areas with multiple images
    else {
      // If a specific image is provided, only remove that image from the array
      if (specificImage) {
        const updatedMaps = floorPlan?.maps?.map((map) => {
          if (map.id === item.id) {
            // If we have multiple images, filter out the specific one
            if (map.images && Array.isArray(map.images)) {
              const filteredImages = map.images.filter(
                (img) => img !== specificImage,
              );

              // If there are still images left, update the array
              if (filteredImages.length > 0) {
                return {
                  ...map,
                  images: filteredImages,
                  img: filteredImages[0], // Set the first remaining image as the primary
                };
              } else {
                // If no images left, clear the img and images properties
                const cleanedItem = { ...map };
                delete cleanedItem.img;
                delete cleanedItem.images;
                return {
                  ...cleanedItem,
                  strokeColor: "rgba(0,0,0,0)",
                  preFillColor: "rgba(0,0,0,0)",
                  fillColor: "rgba(0,0,0,0)",
                };
              }
            }
            // If we only have a single img property and it matches, clear it
            else if (map.img === specificImage) {
              const cleanedItem = { ...map };
              delete cleanedItem.img;
              return {
                ...cleanedItem,
                strokeColor: "rgba(0,0,0,0)",
                preFillColor: "rgba(0,0,0,0)",
                fillColor: "rgba(0,0,0,0)",
              };
            }
            return map;
          }
          return map;
        });

        // Update the floor plan with the modified array
        setFloorPlan({ ...floorPlan, maps: updatedMaps });
      }
      // If no specific image is provided, remove all images for this area (old behavior)
      else {
        const updatedMaps = floorPlan?.maps?.map((map) => {
          if (map.id === item.id) {
            // Remove 'img' and 'images' properties from the map
            const obj1 = {
              strokeColor: "rgba(0,0,0,0)",
              preFillColor: "rgba(0,0,0,0)",
              fillColor: "rgba(0,0,0,0)",
            };

            // Create a new object without the img and images properties
            const cleanedItem = { ...item };
            delete cleanedItem.img;
            delete cleanedItem.images;

            return { ...cleanedItem, ...obj1 };
          }
          return map;
        });

        // Update the floor plan with the modified array
        setFloorPlan({ ...floorPlan, maps: updatedMaps });
      }
    }
  };

  const deleteFurnitureImg = (item) => {
    const updatedFurniture = furniture.filter((map) => map !== item);
    setFurniture(updatedFurniture);
  };

  // Rest of your code remains the same
  const [planFile, setPlanFile] = useState({
    name: null,
    path: null,
  });

  const handlePlanFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPlanFile({
          ...planFile,
          name: file.name,
          path: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const openPdfInNewTab = useCallback(async () => {
    try {
      // Create PDF document
      const pdfBlob = await pdf(
        <Pdf
          floorData={floorPlan}
          fpImg={`${IMG_SERVER_URL}/floorplan/${floorId}.jpg`}
          extFurnitureData={extraFurniture}
          furnitureData={furniture}
          userData={moodBoardUserAPI}
          uploadedPlan={planFile}
        />,
      ).toBlob();

      // Create a URL for the PDF blob using window.URL to ensure compatibility
      if (!window.URL || !window.URL.createObjectURL) {
        throw new Error("Browser does not support URL.createObjectURL");
      }
      const url = window.URL.createObjectURL(pdfBlob);

      // Open PDF in a new tab
      const newWindow = window.open(url, "_blank");

      // Add metadata for better responsiveness
      if (newWindow) {
        newWindow.document.title = "AirBrick Design PDF";

        // Clean up resources when window is closed or loaded
        newWindow.addEventListener("load", () => {
          // Add responsive viewport meta tag to the new window
          const meta = newWindow.document.createElement("meta");
          meta.name = "viewport";
          meta.content =
            "width=device-width, initial-scale=1.0, maximum-scale=5.0";
          newWindow.document.head.appendChild(meta);

          // Add CSS to make PDF responsive in the new window
          const style = newWindow.document.createElement("style");
          style.textContent = `
            body, html {
              margin: 0;
              padding: 0;
              height: 100%;
              width: 100%;
              overflow: auto;
            }
            embed, object, iframe {
              width: 100%;
              height: 100vh;
              border: none;
            }
            @media (max-width: 768px) {
              embed, object, iframe {
                height: calc(100vh - 20px);
              }
            }
          `;
          newWindow.document.head.appendChild(style);
        });

        // Revoke the object URL when the window is closed
        newWindow.addEventListener("beforeunload", () => {
          URL.revokeObjectURL(url);
        });
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      toast.error("Failed to generate PDF. Please try again.");
    }
  }, [
    floorPlan,
    floorId,
    extraFurniture,
    furniture,
    moodBoardUserAPI,
    planFile,
  ]);
  console.log(floorPlan);
  return (
    <Layout>
      {!loading ? (
        <>
          {floorPlan?.maps?.length > 0 ? (
            <div className="px-4 pb-10 ">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex mb-2 items-center justify-center w-7 h-7 rounded-full bg-primary-500 cursor-pointer text-white"
              >
                <Unicons.UilArrowLeft />
              </button>
              <div className="container mx-auto flex gap-x-4">
                <div className="py-4 map-box flex flex-col justify-center items-center bg-slate-100 md:w-[58%] gap-3 rounded-lg">
                  <ImageMapper
                    src={URL}
                    map={MAP}
                    stayMultiHighlighted
                    onClick={openImagePopup}
                    responsive={true}
                    parentWidth={680}
                  />

                  <div className="flex px-3.5">
                    <div className="flex flex-wrap gap-3">
                      <button
                        onClick={() => openFurniturePopup("chair")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Chairs
                      </button>

                      <button
                        onClick={() => openFurniturePopup("lounge_chair")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Lounge Chairs
                      </button>

                      <button
                        onClick={() => openFurniturePopup("pouffes")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Pouffes
                      </button>

                      <button
                        onClick={() => openFurniturePopup("sofa")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Sofa
                      </button>

                      <button
                        onClick={() => openFurniturePopup("glass")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Glass
                      </button>

                      <button
                        onClick={() => openFurniturePopup("table")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Table
                      </button>
                      <button
                        onClick={() => openFurniturePopup("lights")}
                        className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Lights
                      </button>
                    </div>
                    <div className="flex flex-col gap-3">
                      {planFile.name ? (
                        <button className="inline-flex whitespace-nowrap gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white">
                          <span className="truncate w-[100px]">
                            {planFile.name}
                          </span>
                          <Unicons.UilTrashAlt
                            onClick={() =>
                              setPlanFile({ name: null, path: null })
                            }
                            size={20}
                          />
                        </button>
                      ) : (
                        <label className="inline-flex gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white items-center">
                          Upload FloorPlan
                          <Unicons.UilImageUpload size={20} />
                          <input
                            type="file"
                            id="floorpalnImgUpload"
                            className="hidden"
                            accept="image/*"
                            onChange={handlePlanFileChange}
                          />
                        </label>
                      )}

                      <button
                        onClick={openPdfInNewTab}
                        className="inline-flex whitespace-nowrap gap-2 py-2 px-7 rounded-md bg-primary-500 cursor-pointer font-medium text-base text-white"
                      >
                        Create FloorPlan <Unicons.UilFileCheckAlt />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="w-[42%] bg-slate-100 p-3 rounded-lg h-100 max-h-[100vh] overflow-y-scroll no-scrollbar">
                  <div className="columns-3 gap-2 space-y-2">
                    {floorPlan?.maps && (
                      <>
                        {floorPlan?.maps?.map((item, index) => {
                          // Check if we have multiple images
                          if (item.images && Array.isArray(item.images)) {
                            return item.images.map((imgPath, imgIndex) => (
                              <div
                                key={`${index}-${imgIndex}`}
                                className="relative"
                              >
                                <Img
                                  className="w-full rounded-lg object-cover"
                                  src={`${IMG_SERVER_URL}/brick-img${imgPath}.jpg`}
                                />
                                <span
                                  onClick={() => deleteFloorImg(item, imgPath)}
                                  className="absolute z-10 top-1 right-1 bg-slate-100 rounded-md p-1 cursor-pointer hover:bg-slate-200"
                                >
                                  <Unicons.UilTrashAlt size={20} />
                                </span>
                              </div>
                            ));
                          }
                          // Fallback to the old single image display
                          else if (item.img) {
                            return (
                              <div key={index} className="relative">
                                <Img
                                  className="w-full rounded-lg object-cover"
                                  src={`${IMG_SERVER_URL}/brick-img/${item.img}.jpg`}
                                />
                                <span
                                  onClick={() => deleteFloorImg(item, item.img)}
                                  className="absolute z-10 top-1 right-1 bg-slate-100 rounded-md p-1 cursor-pointer hover:bg-slate-200"
                                >
                                  <Unicons.UilTrashAlt size={20} />
                                </span>
                              </div>
                            );
                          }
                          return null;
                        })}
                      </>
                    )}
                    <>
                      {furniture?.map((item, index) => (
                        <div key={index} className="relative">
                          <ImgOptimized
                            className="w-full rounded-lg object-cover"
                            src={`${IMG_SERVER_URL}/furniture/${item}.jpg`}
                          />
                          <span
                            onClick={() => deleteFurnitureImg(item)}
                            className="absolute z-10 top-1 right-1 bg-slate-100 rounded-md p-1 cursor-pointer hover:bg-slate-200"
                          >
                            <Unicons.UilTrashAlt size={20} />
                          </span>
                        </div>
                      ))}
                    </>
                    <>
                      {extraFurniture?.map((item, index) => (
                        <div key={index} className="relative">
                          <ImgOptimized
                            className="w-full rounded-lg object-cover"
                            src={`${IMG_SERVER_URL}/brick-img/${item}.jpg`}
                          />
                          <span
                            onClick={() => deleteFloorImg(item)}
                            className="absolute z-10 top-1 right-1 bg-slate-100 rounded-md p-1 cursor-pointer hover:bg-slate-200"
                          >
                            <Unicons.UilTrashAlt size={20} />
                          </span>
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              </div>

              {popup && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center pop-backdrop"
                  onClick={closeImagePopup}
                >
                  <div className="fixed inset-0 overflow-auto no-scrollbar">
                    <div className="flex items-center justify-center min-h-screen px-4">
                      <div
                        className="relative w-full max-w-5xl mx-auto rounded-lg shadow bg-white dark:bg-gray-700"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {/* Modal header */}
                        <div className="flex items-start justify-between px-4 rounded-t ">
                          <button
                            onClick={closeImagePopup}
                            type="button"
                            className="absolute top-3 right-3 sm:-top-2 sm:-right-2 z-50 bg-[#efefef] hover:bg-gray-200 hover:text-gray-900 rounded-full text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                          >
                            <Unicons.UilTimes />
                          </button>
                        </div>
                        {/* Modal body */}
                        <div className="p-5 min-h-[70vh]">
                          <InfiniteScroll
                            dataLength={chooseImages.length} // This is important field to render the next data
                            next={fetchImages}
                            className="no-scrollbar"
                            height={"80vh"}
                            hasMore={hasMore} // Use the state variable to control if there's more data to load
                            loader={
                              <div className="flex justify-center gap-x-2 font-bold text-lg">
                                <Unicons.UilSync
                                  className="animate-spin"
                                  color="#008080"
                                />{" "}
                                Loading...
                              </div>
                            }
                            endMessage={
                              <p className="w-full text-center">
                                Yay! You have seen it all
                              </p>
                            }
                          >
                            <ResponsiveMasonry
                              columnsCountBreakPoints={{
                                350: 1,
                                750: 2,
                                900: 3,
                              }}
                            >
                              <Masonry gutter="1rem">
                                {chooseImages.map((option, index) => (
                                  <div key={index} className="relative mb-2">
                                    <input
                                      type="checkbox"
                                      id={option?._id}
                                      name="checkbox-group"
                                      value={`/${option._id}`}
                                      checked={selectedOptions.includes(
                                        `/${option._id}`,
                                      )}
                                      onChange={() =>
                                        toggleImageSelection(option)
                                      }
                                      className="hidden"
                                    />
                                    <label
                                      htmlFor={option._id}
                                      className="w-full cursor-pointer rounded-lg"
                                    >
                                      <Img
                                        src={`${IMG_SERVER_URL}/brick-img/${option?._id}.jpg`}
                                        alt={option?._id}
                                        className="rounded-xl"
                                      />

                                      {selectedOptions.includes(
                                        `/${option._id}`,
                                      ) && (
                                        <div className="absolute top-[30px] left-[10px] z-10 bg-green-400 rounded-full flex items-center justify-center text-white">
                                          <Unicons.UilCheckCircle />
                                        </div>
                                      )}
                                    </label>
                                  </div>
                                ))}
                              </Masonry>
                            </ResponsiveMasonry>
                          </InfiniteScroll>
                        </div>
                        {/* Modal footer */}
                        <div className="flex items-center justify-end p-5 pt-1 rounded-b gap-3">
                          <button
                            type="button"
                            onClick={closeImagePopup}
                            className="text-white text-sm bg-green-500 hover:bg-green-600 py-2 px-8 rounded-lg"
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {furniturePopup && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center pop-backdrop"
                  onClick={closeFurniturePopup}
                >
                  <div className="fixed inset-0">
                    <div className="flex items-center justify-center min-h-screen px-4">
                      <div
                        className="relative w-full max-w-5xl mx-auto rounded-lg shadow bg-white dark:bg-gray-700"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {/* Modal header */}
                        <div className="flex items-start justify-between px-4 rounded-t ">
                          <button
                            onClick={closeFurniturePopup}
                            type="button"
                            className="absolute top-3 right-3 sm:-top-2 sm:-right-2 z-50 bg-[#efefef] hover:bg-gray-200 hover:text-gray-900 rounded-full text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                          >
                            <Unicons.UilTimes />
                          </button>
                        </div>
                        {/* Modal body */}
                        <div className="p-5 min-h-[70vh]">
                          <InfiniteScroll
                            dataLength={chooseFurniture.length} // This is important field to render the next data
                            next={fetchFurniture}
                            height={"80vh"}
                            className="no-scrollbar"
                            hasMore={hasFurnitureMore} // Use the state variable to control if there's more data to load
                            loader={
                              <div className="flex justify-center gap-x-2 font-bold text-lg">
                                <Unicons.UilSync
                                  className="animate-spin"
                                  color="#008080"
                                />{" "}
                                Loading...
                              </div>
                            }
                            endMessage={
                              <p className="w-full text-center">
                                Yay! You have seen it all
                              </p>
                            }
                          >
                            <ResponsiveMasonry
                              columnsCountBreakPoints={{
                                350: 1,
                                600: 2,
                                950: 3,
                                1100: 4,
                              }}
                            >
                              <Masonry gutter={"1.2rem"}>
                                {chooseFurniture?.map((option, index) => {
                                  const value = `${option.Mask}/${option.ID}`;
                                  const isSelected =
                                    selectedFurnitureOptions.includes(value);

                                  return (
                                    <div key={index} className="relative mb-2">
                                      <input
                                        type="checkbox"
                                        id={option._id}
                                        name="checkbox-group"
                                        value={value}
                                        checked={isSelected}
                                        onChange={() =>
                                          toggleFurnitureSelection(option)
                                        }
                                        className="hidden"
                                      />
                                      <label
                                        htmlFor={option._id}
                                        className="w-full cursor-pointer block relative"
                                      >
                                        <ImgOptimized
                                          src={`${IMG_SERVER_URL}/furniture/${option.Mask}/${option.ID}.jpg`}
                                          alt={option._id}
                                          className={`rounded-xl border-2 shadow-lg w-full ${
                                            isSelected ? "border-green-400" : ""
                                          }`}
                                        />
                                        {isSelected && (
                                          <div className="absolute top-[10px] left-[10px] z-10 bg-green-500 rounded-full p-1 text-white">
                                            <Unicons.UilCheckCircle size="20" />
                                          </div>
                                        )}
                                      </label>
                                    </div>
                                  );
                                })}
                              </Masonry>
                            </ResponsiveMasonry>
                          </InfiniteScroll>
                        </div>
                        {/* Modal footer */}
                        <div className="flex items-center justify-end p-5 pt-1 rounded-b gap-3">
                          <button
                            type="button"
                            onClick={closeFurniturePopup}
                            className="text-white text-sm bg-green-500 hover:bg-green-600 py-2 px-8 rounded-lg"
                          >
                            Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {pdfView && (
                <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[99999] h-screen w-screen bg-gradient-to-r from-[rgba(0,0,0,0.5)] to-[rgba(0,0,0,0.5)]">
                  <button
                    className="absolute top-2 right-7 bg-white p-2 rounded-full"
                    onClick={() => setPdfView(false)}
                  >
                    <Unicons.UilTimes size={25} />
                  </button>
                  <PDFViewer className="mx-auto" width="80%" height="100%">
                    <Pdf
                      floorData={floorPlan}
                      fpImg={`${IMG_SERVER_URL}/floorplan/${floorId}.jpg`}
                      extFurnitureData={extraFurniture}
                      furnitureData={furniture}
                      userData={moodBoardUserAPI}
                      uploadedPlan={planFile}
                    />
                  </PDFViewer>
                </div>
              )}
            </div>
          ) : (
            <NoResultsComponent />
          )}
        </>
      ) : (
        <Loader />
      )}
    </Layout>
  );
};

export default Moodboard;
